export default __webpack_public_path__ + "static/media/ThematicDisplay.b55fd4b4.png";